module.exports = __webpack_public_path__ + "teqbahn-assets/media/40.8b8dc92d.png";